import { render, staticRenderFns } from "./BenefitsMkRuTinkoff.vue?vue&type=template&id=0aecd11a"
import script from "./BenefitsMkRuTinkoff.vue?vue&type=script&lang=js"
export * from "./BenefitsMkRuTinkoff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports